import { useCallback, useEffect, useState } from "react";
import { getFeatureFlag } from "src/services/feature-flag.service";


interface UseFeatureFlagReturn {
  isEnabled: boolean | null;
  refetch: () => Promise<void>;
}
const cache = new Map<string, boolean>();

export const useFeatureFlag = (
  flagName: string,
): UseFeatureFlagReturn => {
  const featureValue = cache.get(flagName);
  const [isEnabled, setIsEnabled] = useState<boolean>(featureValue ?? false);

  const loadFlag = useCallback(async () => {
    try {
      const { isEnabled: featureFlagEnabled, error } = await getFeatureFlag({
        flagName
      });

      if (error) {
        setIsEnabled(false);
        return;
      }
      setIsEnabled(featureFlagEnabled ?? false);
      cache.set(flagName, featureFlagEnabled ?? false);
    } catch (err) {
      setIsEnabled(false);
    }
  }, [flagName, setIsEnabled]);

  useEffect(() => {
    const fetchFeatureFlag = async () => {
      await loadFlag();
    };

    if (!cache.has(flagName)) {
      fetchFeatureFlag();
    }
  }, [flagName, loadFlag]);

  const refetch = async () => {
    cache.delete(flagName);
    await loadFlag();
  };

  return { isEnabled, refetch };
};
